import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

const ProductionMaterials = () => {
  const theme = useTheme();
  const accent = theme.palette.secondary.main;

  return (
    <Box sx={{ mb: 6 }}>
      <Typography variant="h4" fontWeight={700} color="primary" gutterBottom align="center">
        Material para producción (antena y radio)
      </Typography>
      <Grid container spacing={3} sx={{ mt: 1 }}>
        <Grid item xs={12} md={4}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              height: '100%',
              border: `1px solid ${theme.palette.divider}`,
              borderTop: `4px solid #93c5fd`,
            }}
          >
            <Typography variant="h6" fontWeight={700} gutterBottom>
              En pantalla
            </Typography>
            <Box component="ul" sx={{ m: 0, pl: 2.5, color: 'text.secondary' }}>
              <Typography component="li" variant="body2" sx={{ mb: 1, lineHeight: 1.7 }}>
                Cintillo animado en consejos familiares: «Este pedacito de cielo es traído a ti por Papaupa».
              </Typography>
              <Typography component="li" variant="body2" sx={{ lineHeight: 1.7 }}>
                Logo de Papaupa en la despedida de cada bloque de los tres programas.
              </Typography>
            </Box>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              height: '100%',
              border: `1px solid ${theme.palette.divider}`,
              borderTop: `4px solid ${accent}`,
            }}
          >
            <Typography variant="h6" fontWeight={700} gutterBottom>
              En radio (rotativa / micros)
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ fontStyle: 'italic', lineHeight: 1.8 }}>
              Voz de marca: «¿Buscas ese pedacito de cielo para tu familia? Papaupa te acompaña en cada paso:
              desde la fe, la crianza y el crecimiento de tus hijos. Calidad que protege y une. Un aliado de TNO
              Network.»
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={4}>
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              height: '100%',
              border: `1px solid ${theme.palette.divider}`,
              borderTop: `4px solid #c4b5fd`,
            }}
          >
            <Typography variant="h6" fontWeight={700} gutterBottom>
              En programa (menciones)
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1.5, lineHeight: 1.7 }}>
              <strong>Somos Padres (Dra. Leila):</strong> «Gracias a nuestros amigos de Papaupa, que entienden
              que proteger a los niños es nuestra mayor misión».
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ lineHeight: 1.7 }}>
              <strong>Punto de Fe:</strong> «Cerramos este segmento recordando que Dios nos regala pedacitos de
              cielo, como los que Papaupa lleva a tu hogar».
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProductionMaterials;
